import * as React from 'react';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/12px/chevron-left.svg';
import { UnstyledButton } from '@catapultsports/referee-react';
interface SettingsBackButtonProps {
    label: string;
    showIcon?: boolean;
    onClick: () => void;
}

export const SettingsBackButton: React.FunctionComponent<SettingsBackButtonProps> = ({ label, onClick }) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            height: '48px',
            paddingLeft: '10px',
            zIndex: 22,
        }}
    >
        <UnstyledButton className="settings-back-button" onClick={onClick}>
            <ChevronLeftIcon />
            {label}
        </UnstyledButton>
    </div>
);
